'use client'

import clsx from 'clsx'
import * as React from 'react'

export const BshbPortalVideo = ({
  portal,
  className,
}: {
  className?: string
  portal: {
    url: string
    aspectRatio?: string
  }
}) => {
  const videoRef = React.useRef<HTMLVideoElement>(null)

  React.useEffect(() => {
    const video = videoRef.current
    if (!video) return

    video.playbackRate = 1.5 // Set playback speed to 1.5x
    const handleTimeUpdate = () => {
      const threshold = 0.93
      if (video.currentTime / video.duration >= threshold) {
        video.currentTime = 0
        video.play()
      }
    }

    video.addEventListener('timeupdate', handleTimeUpdate)
    return () => video.removeEventListener('timeupdate', handleTimeUpdate)
  }, [])

  return (
    <div
      style={{ aspectRatio: portal.aspectRatio ?? '1 / 1' }}
      className={clsx(
        'w-full max-w-32 xl:max-w-44 md:-translate-x-10 xl:-translate-x-14',
        className
      )}
    >
      <video ref={videoRef} src={portal.url} autoPlay playsInline muted loop />
    </div>
  )
}
